import { useCDNUrl, useWriteKey } from "@lib/hooks/useConfig"
import { AnalyticsBrowser } from "@segment/analytics-next"
import React from "react"

// @ts-ignore
const AnalyticsContext = React.createContext<{
  analytics: AnalyticsBrowser
  writeKey: string
  setWriteKey: (key: string) => void
  cdnURL: string
  setCDNUrl: (url: string) => void
}>()

export const AnalyticsProvider = ({ children }: { children: any }) => {
  const [writeKey, setWriteKey] = useWriteKey()
  const [cdnURL, setCDNUrl] = useCDNUrl()

  const analytics = React.useMemo(() => {
    console.log(`AnalyticsBrowser loading...`, JSON.stringify({ writeKey, cdnURL }))
    // @ts-ignore
    return AnalyticsBrowser.load({ writeKey, cdnURL })
  }, [writeKey, cdnURL])
  return (
    // @ts-ignore
    <AnalyticsContext.Provider value={{ analytics, writeKey, setWriteKey, cdnURL, setCDNUrl }}>
      {children}
    </AnalyticsContext.Provider>
  )
}

// Create an analytics hook that we can use with other components.
export const useAnalytics = () => {
  const result = React.useContext(AnalyticsContext)
  if (!result) {
    throw new Error("Context used outside of its Provider!")
  }
  return result
}
